<template>
    <div class="inline-flex items-center rounded-full bg-slate-100 px-2 py-1 text-xs">
        <span class="mr-1 font-medium">{{ displayLabel }}:</span>
        <span>{{ displayValue }}</span>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    filter: {
        type: Object,
        required: true,
    },
})

// Format the label to be more user-friendly
const displayLabel = computed(() => {
    if (!props.filter?.id) return 'Filter'

    // Map special filter IDs to friendly names
    const specialMappings = {
        day_range: 'Timeframe',
        content_type: 'Format',
        min_matched_games: 'Minimum matching games',
    }

    if (specialMappings[props.filter.id]) {
        return specialMappings[props.filter.id]
    }

    // Otherwise format the ID nicely
    return props.filter.id
        .replace(/_/g, ' ')
        .replace(/-/g, ' ')
        .split('.')
        .pop()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
})

// Format the value to be more user-friendly
const displayValue = computed(() => {
    if (props.filter.id === 'day_range') {
        if (props.filter.value === 30) return '30 days'
        if (props.filter.value === 90) return '90 days'
        if (props.filter.value === 365) return '1 year'
        return `${props.filter.value} days`
    }

    if (props.filter.id === 'content_type') {
        return props.filter.value.charAt(0).toUpperCase() + props.filter.value.slice(1)
    }

    if (Array.isArray(props.filter.value)) {
        if (props.filter.value.length === 0) return 'None'
        return `${props.filter.value.length} selected`
    }

    if (typeof props.filter.value === 'boolean') {
        return props.filter.value ? 'Yes' : 'No'
    }

    if (typeof props.filter.value === 'object' && props.filter.value !== null) {
        return 'Complex filter'
    }

    return props.filter.value
})
</script>
